





























































// vue
import {
    defineComponent,
    onBeforeMount,
    ref,
    watchEffect,
} from '@vue/composition-api';
import { useStore } from '@/store';

// services
import { useService } from '@/vue3/api/services';

// components
import Surface from '@/vue3/components/Surface.vue';

export default defineComponent({
    props: {
        currentHole: {
            type: Number,
            default: 0,
        },
    },
    components: {
        Surface,
    },
    setup(props: any) {
        // hooks
        const store = useStore();
        const { getTotalFeatureAreas, getFeatureAreasByHole } = useService();

        // reactive
        const features = ref();
        const isDataLoaded = ref(false);
        const isMeters = ref(false);

        // methods
        const getFeatureData = async () => {
            isMeters.value = store.state.isMeters;

            if (props.currentHole === null) {
                features.value = await getTotalFeatureAreas(
                    store.getters.currentCourseSchema.id,
                );
            } else {
                features.value = await getFeatureAreasByHole(
                    props.currentHole,
                    store.getters.currentCourseSchema.id,
                );
            }
            isDataLoaded.value = true;
            features.value = features.value.filter(function (feature) {
                return feature.area !== null;
            });
        };

        // lifecycle
        onBeforeMount(() => {
            getFeatureData();
        });

        watchEffect(() => getFeatureData());

        return {
            features,
            isDataLoaded,
            isMeters,
        };
    },
});
